'use strict';

var GridAddSpecialEventButtonDirective = function GridAddSpecialEventButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-add-special-event-button.html'),
    controller: 'GridAddSpecialEventButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', $scope.onRowSelection);
      $scope.$watch('displayedCalendar.specialEvents', $scope.handleSpecialEventUpdates);
    }
  };
};
GridAddSpecialEventButtonDirective.$inject = [];
module.exports = GridAddSpecialEventButtonDirective;